class SiteElementCarousel
    extends QueryElement<HTMLElement> {

    private _items: QueryElement<HTMLElement>;
    private _nav: QueryElement<HTMLElement>;
    private _numberOfItems: number;
    private _active: number = 0;
    private _timer: number | undefined;
    
    
    constructor(element: HTMLElement) {
        super(element);

        let items = this.query(".items").first<QueryElement<HTMLElement>>();
        
        if (items == null)
            throw "Element(s) not found!";

        this._items = items;
        this._nav = QueryElement.QueryElement("DIV")
            .addClass("nav")
            .appendTo(this);
        this._numberOfItems = items.children().length;
        
        for(let x = 0; x < this._numberOfItems; x++) {
            QueryElement.QueryElement("DIV")
                .appendTo(this._nav)
                .on("click", a => {
                    this.makeActive(x);
                });
        }

        this.makeActive(0);
    }

    setTimer() {
        if (this._timer != null)
            clearTimeout(this._timer);

        this._timer = setTimeout(() => {
            this.makeNextActive();
        }, 5000);
    }
    makeActive(index: number) {
        this.makeInactive(this._active);
        this.setTimer();
        
        this._active = index;

        var style = this._items.style();
        if (style != null)
            style.transform = `translateX(-${index * 100}%)`;
        
        this._nav.children()[index].addClass("active");
    }
    private makeInactive(index: number) {
        this._nav.children()[index].removeClass("active");
    }
    makeNextActive() {
        var next = this._active + 1;
        if (next > (this._numberOfItems - 1))
            next = 0;
        
        this.makeActive(next);
    }
    makePrevActive() {
        var prev = this._active - 1;
        if (prev < 0)
            prev = this._numberOfItems - 1;
        
        this.makeActive(prev);
    }


}